import { useContext, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Close } from '@mui/icons-material';
import { CityContext } from '../../ContextApi/cityContext';
import './AppPromo.css';

// "יש לנו אפליקציה": חלון קטן מתחתית המסך (לא מסך מלא - Google מורידה בדירוג על intrusive interstitials).
// - רק במובייל (Android / iOS לפי ה-User-Agent), ולא בתוך האפליקציה עצמה (AshdodMenuApp, מגרסה 1.0.11).
// - לא מיד: אחרי SHOW_DELAY או במעבר לעמוד השני, מה שקודם.
// - סגירה (X / "לא עכשיו" / הכפתור הראשי) -> לא מוצג שוב HIDE_DAYS ימים (localStorage).
// - לא בעמודי הזמנה ותשלום, ולא כשבורר העיר פתוח.
// בנוסף מעדכן את app-argument של הבאנר של Safari בכל מעבר עמוד (התגית נוספת ב-public/index.html).

const APP_ID_IOS = '6471904204';
const ANDROID_PKG = 'com.asdodmenu.app'; // בכוונה בלי h - זה המזהה ב-Google Play
const SITE_HOST = 'www.ashdodmenu.co.il';
const STORE_KEY = 'amAppPromoHiddenAt';
const HIDE_DAYS = 3;
const SHOW_DELAY = 6000;
// הפופ-אפ כבוי זמנית: הקישור לאפליקציה מוביל למקום שבור. עדכון app-argument של Safari ממשיך לעבוד.
const PROMO_ENABLED = false;

// עמודי הזמנה ותשלום
const NO_PROMO_PATHS = ['/MyOrder', '/TakeOrDel', '/deliAdress', '/thankU', '/ErrorPay', '/LoginPage', '/UserDetails'];

const ua = typeof navigator !== 'undefined' ? (navigator.userAgent || '') : '';
export const inApp = /AshdodMenuApp/.test(ua);
const isAndroid = /Android/i.test(ua);
// iPadOS מזדהה כ-Macintosh, ומובחן לפי מסך מגע
const isIOS = /iPhone|iPad|iPod/i.test(ua) ||
    (/Macintosh/.test(ua) && typeof navigator !== 'undefined' && navigator.maxTouchPoints > 1);

const hiddenRecently = () => {
    try {
        const at = Number(localStorage.getItem(STORE_KEY));
        return !!at && (Date.now() - at) < HIDE_DAYS * 24 * 60 * 60 * 1000;
    } catch (e) {
        return false;
    }
};

const rememberHidden = () => {
    try { localStorage.setItem(STORE_KEY, String(Date.now())); } catch (e) { }
};

const androidLink = (path) =>
    `intent://${SITE_HOST}${path}#Intent;scheme=https;package=${ANDROID_PKG};` +
    `S.browser_fallback_url=${encodeURIComponent(`https://play.google.com/store/apps/details?id=${ANDROID_PKG}`)};end`;

const AppPromo = () => {
    const location = useLocation();
    const { cities, city, needsMyCity, ready, pickerOpen } = useContext(CityContext);
    const [due, setDue] = useState(false); // עבר הזמן או שעברו עמוד
    const [hidden, setHidden] = useState(hiddenRecently);
    const firstPath = useRef(location.pathname);

    const path = location.pathname + location.search + location.hash;

    // app-argument של הבאנר של Safari - הכתובת הנוכחית
    useEffect(() => {
        if (inApp) return;
        const meta = document.querySelector('meta[name="apple-itunes-app"]');
        if (meta) meta.setAttribute('content', `app-id=${APP_ID_IOS}, app-argument=${window.location.href}`);
    }, [path]);

    // אחרי כמה שניות
    useEffect(() => {
        if (inApp || !(isAndroid || isIOS)) return;
        const t = setTimeout(() => setDue(true), SHOW_DELAY);
        return () => clearTimeout(t);
    }, []);

    // או במעבר לעמוד השני
    useEffect(() => {
        if (location.pathname !== firstPath.current) setDue(true);
    }, [location.pathname]);

    if (!PROMO_ENABLED || inApp || !(isAndroid || isIOS) || !due || hidden) return null;
    if (NO_PROMO_PATHS.some(p => location.pathname.startsWith(p))) return null;
    // בורר העיר פתוח (או עומד להיפתח)
    if (!ready || (cities.length > 0 && (pickerOpen || !city || needsMyCity))) return null;

    const close = () => {
        rememberHidden();
        setHidden(true);
    };

    const href = isAndroid ? androidLink(path) : `https://apps.apple.com/app/id${APP_ID_IOS}`;

    return (
        <div className="appPromo" role="dialog" aria-label="האפליקציה של אשדוד בתפריט" dir="rtl">
            <button className="appPromoClose" onClick={close} aria-label="סגור">
                <Close fontSize="small" />
            </button>
            <div className="appPromoTitle">יש לנו אפליקציה!</div>
            <div className="appPromoTxt">הזמנות מהירות יותר ומנות בלעדיות לאפליקציה</div>
            <div className="appPromoBtns">
                <a className="appPromoMain" href={href} onClick={close}
                    {...(isAndroid ? {} : { target: '_blank', rel: 'noopener noreferrer' })}>
                    {isAndroid ? 'פתח באפליקציה' : 'הורד מה-App Store'}
                </a>
                <button className="appPromoLater" onClick={close}>לא עכשיו</button>
            </div>
        </div>
    );
};

export default AppPromo;
